/**
 * API for contact CRUD.
 * PATCH /consumer/contacts/:id - update contact (fullName, email).
 */

import { apiClient } from "./auth";
import type {
  PatchContactPayload,
  PatchContactResponse,
} from "../Interfaces/ContactInterface";

/**
 * PATCH /consumer/contacts/:id
 * Updates a contact. Only fullName and email are supported by the backend.
 */
export const patchContactApi = async (
  contactId: string,
  payload: PatchContactPayload
): Promise<PatchContactResponse> => {
  const response = await apiClient.patch<
    PatchContactPayload,
    PatchContactResponse
  >(`/consumer/contacts/${encodeURIComponent(contactId)}`, payload);
  return response.data;
};
